import { render } from "./SoldAssetResultDialog.vue?vue&type=template&id=2dea5a46"
import script from "./SoldAssetResultDialog.vue?vue&type=script&lang=js"
export * from "./SoldAssetResultDialog.vue?vue&type=script&lang=js"

import exportComponent from "/w/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__